import { render, staticRenderFns } from "./claustro-listado.vue?vue&type=template&id=32f820fa&scoped=true&"
import script from "./claustro-listado.component.ts?vue&type=script&lang=ts&"
export * from "./claustro-listado.component.ts?vue&type=script&lang=ts&"
import style0 from "./claustro-listado.vue?vue&type=style&index=0&id=32f820fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f820fa",
  null
  
)

export default component.exports